<template>
  <svg width="23" height="41" viewBox="0 0 23 41" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="21" height="39" rx="3" stroke-width="2" />
    <line x1="1" y1="6" x2="22" y2="6" stroke-width="2" />
    <line x1="1" y1="35" x2="22" y2="35" stroke-width="2" />
  </svg>
</template>
